"use strict";

angular.module("vendor")
.directive("header", function() {
    return {
        templateUrl: require("./header.html"),
        controller: HeaderController,
        controllerAs: "headerCtrl"
    };
});

function HeaderController(
    $scope, $rootScope, $cookies, $window, $state, $stateParams, ToggleNav, gettextCatalog, UserService
) {
    var _this = this;
    $scope.isCollapsed = ToggleNav.isCollapsed();

    $scope.searchTypes = [
        {
            id: "customerManagement",
            label: "Customers",
            translationExtraction: gettextCatalog.getString("Customers"),
            hasOwnSearch: true
        },
        {id: "productsList", label: "Products", translationExtraction: gettextCatalog.getString("Products")},
        {id: "ordersList", label: "Orders", translationExtraction: gettextCatalog.getString("Orders")},
        {id: "invoiceList", label: "Invoices", translationExtraction: gettextCatalog.getString("Invoices")},
        {id: "paymentList", label: "Payments", translationExtraction: gettextCatalog.getString("Payments")},
        {id: "catalogsList", label: "Catalogs", translationExtraction: gettextCatalog.getString("Catalogs")},
        {
            id: "salesRepresentativesList",
            label: "Sales representatives",
            translationExtraction: gettextCatalog.getString("Sales representatives")
        },
        {id: "importLogList", label: "Import Log", translationExtraction: gettextCatalog.getString("Import Log")}
    ];
    $scope.search = {
        term: $stateParams.search || null,
        section: $scope.searchTypes[0]
    };
    $scope.search.section = $scope.searchTypes[0];

    this.toggle = function() {
        ToggleNav.toggle();
    };

    this.search = function() {
        if ($scope.search.term === "") {
            this.clearSearch();
        }
        else {
            var state = ($state.current !== $scope.search.section.id) ? $scope.search.section.id : '.';
            $state.go(state, {
                search: $scope.search.term
            });

            if ($scope.search.section.hasOwnSearch) {
                $scope.search.term = null;
            }
        }
    };

    this.clearSearch = function() {
        $scope.search.term = undefined;
        delete $stateParams['search'];
        $state.go('.', $stateParams);
    };

    angular.element(document).on("click", "#mobile-nav .navbar-nav", function() {
        angular.element("#mobile-nav").collapse("hide");
    });

    this.closeMobileNav = function() {
        angular.element("#mobile-nav").collapse("hide");
    };

    this.focusSearchBar = function() {
        angular.element("#SearchBox").focus();
    };

    this.logoutAndRedirect = function(route) {
        UserService.logoutAndRedirect(route)
    };

    this.back = function() {
        angular.element("#mobile-nav").collapse("hide");
        $window.history.back();
    };

    function updateElementsFromState(state) {
        if (state.title) {
            $scope.title = state.title(gettextCatalog);
        }

        if (state && state.defaultSearchSection !== undefined) {
            $scope.search.section = _.find($scope.searchTypes, function(section) {
                return section.id === state.defaultSearchSection;
            });
        }
        else {
            $scope.search.section = $scope.searchTypes[0];
        }

        if ($scope.search.section.hasOwnSearch) {
            $scope.search.term = null;
        }

        $scope.backVisible = !state.hideBackButton;
    }

    this.getUserName = function() {
        if ($rootScope.user) {
            if ($rootScope.user.info.is_impersonator && $rootScope.user.vendor) {
                return $rootScope.user.vendor.Name;
            }
            else {
                return $rootScope.user.username;
            }
        }
        else {
            return "";
        }
    }

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        updateElementsFromState($state.current);
    });

    var unregisterStateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
        updateElementsFromState(toState);

        if (!$stateParams.search) {
            _this.clearSearch();
        }
    });

    updateElementsFromState($state.current);

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
        unregisterLanguageChanged = null;

        unregisterStateChangeSuccess();
        unregisterStateChangeSuccess = null;
    });
}



//////////////////
// WEBPACK FOOTER
// ./vendor/header/header.controller.js
// module id = 793
// module chunks = 0